// Cobro en el mostrador de un ticket que quedó pendiente de pago — típicamente una venta web con
// "Pago en tienda" (backend docs/spec-caja.md D-04; PR backend fix/sellar-pago-en-tienda).
//
// La web declara EFECTIVO para todo "pago en tienda", pero el cliente puede pagar con tarjeta o
// transferencia. Al marcarlo pago, el backend sella el ticket contra la caja abierta con el medio
// que tenga: si el mostrador no dice con qué pagó, una tarjeta se cuenta como efectivo y el
// arqueo da un faltante que no existe. Por eso "Pagado" pregunta el medio, y con tarjeta el lector.

// Los medios con que se cobra en el mostrador. Mercado Pago y Mercado Libre se cobran online (el
// backend rechaza elegirlos al cobrar, 4402) y los de $0 no son un cobro.
export const MEDIOS_DE_MOSTRADOR = [
    { code: 1, label: 'Efectivo' },
    { code: 2, label: 'Transferencia' },
    { code: 5, label: 'Tarjeta (POS)' },
];

const POS = 5;

// Los estados de un ticket NO pago: el mismo criterio del backend (CashSessionController
// UNPAID_STATUSES). El cobro es pasar de uno de estos a Pago.
const ESTADOS_NO_PAGOS = [0, 3, 7];
const PAGO = 2;

export const cobraEnMostrador = (paymentType) =>
    MEDIOS_DE_MOSTRADOR.some((m) => m.code === Number(paymentType));

// ¿Se ofrece elegir con qué pagó? Sólo en un ticket pendiente cuyo medio ya es de mostrador. Un
// pedido de Mercado Pago sigue como hasta hoy (se marca pago sin elegir nada y no entra a la caja):
// si el cliente abandonó el pago online y pagó en el local, lo corrige el admin desde Tickets.
export const ofreceElegirMedio = (currentStatus, currentPaymentType) =>
    ESTADOS_NO_PAGOS.includes(Number(currentStatus)) && cobraEnMostrador(currentPaymentType);

// El lector preseleccionado: el de la tienda, que es donde se cobra lo que se compró en la web.
// Queda visible para cambiarlo.
export function lectorDeTienda(devices) {
    if (!Array.isArray(devices) || devices.length === 0) return null;
    return devices.find((d) => /tienda/i.test(d.name))
        || devices.find((d) => !/cafeter/i.test(d.name))
        || devices[0];
}

/**
 * El cuerpo de PATCH /ticket/status.
 *
 * El medio y el lector viajan SÓLO en el cobro (pendiente → Pago) de un ticket que los ofrece: el
 * backend los rechaza con 1001 en cualquier otro cambio de estado. El lector, sólo con tarjeta.
 * `cobro` es lo elegido en CobroPendienteFields ({ paymentType, posDeviceId }); sin él —un ticket
 * que no ofrece elegir— se manda sólo el estado, como siempre.
 */
export function cuerpoDelCobro({ ticketId, status, currentStatus, currentPaymentType, cobro }) {
    const body = { ticketId: Number(ticketId), status };
    const esCobro = Number(status) === PAGO && ofreceElegirMedio(currentStatus, currentPaymentType);
    if (!esCobro || !cobro || !cobraEnMostrador(cobro.paymentType)) {
        return body;
    }
    body.paymentType = Number(cobro.paymentType);
    if (body.paymentType === POS && cobro.posDeviceId) {
        body.posDeviceId = Number(cobro.posDeviceId);
    }
    return body;
}
